export default __webpack_public_path__ + "static/media/wordpairs_preex.44346c14.svg";